import { Suspense } from 'react'
import { Toaster } from 'sonner'
import { AppProviders } from '@/app/providers/AppProviders'
import { AppRouter } from '@/app/router/AppRouter'
import { FullPageLoader } from '@/shared/ui/FullPageLoader'

export default function App() {
  return (
    <AppProviders>
      <Suspense fallback={<FullPageLoader />}>
        <AppRouter />
      </Suspense>
      <Toaster position="top-center" richColors />
    </AppProviders>
  )
}
